import React from 'react';
import { observer } from 'mobx-react';
import { Table } from 'antd';
import { TableLogFieldValue } from '../../TableLogFieldValue';
import cx from 'classnames';
import { IPaperTrailLogsItem } from '../../../interfaces';
import { usePaperTrailLogsTable, useUiIsLoading } from '../../../hooks';
import { dateText2Utc } from '../../../instruments';
import { tF } from '../../../translate';
import { Catcher, LightSearch } from '../../../Components';
import Styles from '../../styles/m_viewStyles.less';

export const PaperTrailLogsTableList: React.FC = observer(() => {
    const isLoading = useUiIsLoading();
    const list = usePaperTrailLogsTable();

    const tableColumns = [
        {
            title: 'Action',
            dataIndex: 'event',
        },
        {
            title: 'Entity Type',
            dataIndex: 'item',
        },
        {
            title: 'Company Id',
            dataIndex: 'companyId',
        },
        {
            title: 'User Id',
            dataIndex: 'userId',
        },
        {
            title: 'Controller Name',
            dataIndex: 'controllerName',
        },
        {
            title: 'Controller Action',
            dataIndex: 'controllerAction',
        },
        {
            title: 'Jid',
            dataIndex: 'jid',
        },
        {
            title: 'Action Id',
            dataIndex: 'actionId',
        },
        {
            title: tF('Created at'),
            dataIndex: 'createdAt',
        },
    ];
    const tableData = list.map((p: IPaperTrailLogsItem, index) => {
        return {
            key: p.id,
            item: (
                <span>
                    <LightSearch text={p.itemType} />
                    <span>
                        <span>: </span>
                        <TableLogFieldValue entity={p.itemType} value={p.itemId} prop={'id'} />
                    </span>
                </span>
            ),
            ...p,
            createdAt: dateText2Utc(p.createdAt),
        };
    });

    return (
        <Catcher>
            <div className={cx(Styles.tablePlace)}>
                <Table
                    dataSource={tableData}
                    columns={tableColumns}
                    pagination={false}
                    className={'table-theme'}
                    size={'middle'}
                    loading={isLoading}
                />
            </div>
        </Catcher>
    );
});
